// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.details-box .details-item + .details-item[data-v-6da316ae] {\n  border-top: 1px solid #f4f5f8;\n}\n.details-box + .details-box[data-v-6da316ae] {\n  margin-top: 2rem;\n}\n", ""]);
// Exports
module.exports = exports;
